import { searchParamsToString, } from '@moderepo/mode-data-state-base';
import { RitzAPI, } from '@moderepo/mode-internal-apis';
/**
 * The types of action that can be dispatched to update this sub state.
 */
export var FirmwareActionType;
(function (FirmwareActionType) {
    FirmwareActionType["SET_FIRMWARE_CHANNELS"] = "set firmware channels";
    FirmwareActionType["CLEAR_FIRMWARE_CHANNELS"] = "clear firmware channels";
    FirmwareActionType["SET_FIRMWARE_BUNDLES"] = "set firmware bundles";
    FirmwareActionType["CLEAR_FIRMWARE_BUNDLES"] = "clear firmware_bundles";
})(FirmwareActionType || (FirmwareActionType = {}));
/**
 * Set the list of firmware channels to the state
 */
export const setFirmwareChannels = (projectId, channels, searchParams) => {
    return {
        type: FirmwareActionType.SET_FIRMWARE_CHANNELS,
        projectId,
        channels,
        searchParams,
    };
};
/**
 * Clear the list of firmware channels from the state
 */
export const clearFirmwareChannels = (projectId) => {
    return {
        type: FirmwareActionType.CLEAR_FIRMWARE_CHANNELS,
        projectId,
    };
};
/**
 * Set the list of firmware bundles to the state
 */
export const setFirmwareBundles = (projectId, bundles, searchParams) => {
    return {
        type: FirmwareActionType.SET_FIRMWARE_BUNDLES,
        projectId,
        bundles,
        searchParams,
    };
};
/**
 * Clear the list of firmware bundles from the state
 */
export const clearBundles = (projectId) => {
    return {
        type: FirmwareActionType.CLEAR_FIRMWARE_BUNDLES,
        projectId,
    };
};
/**
 * Get multiple firmware channels belonged to a Project
 * @param projectId - The id of the project to look for
 */
export const fetchProjectFirmwareChannels = (projectId, deviceClass) => {
    return async (dataDispatch) => {
        const channels = await RitzAPI.getInstance().getProjectFirmwareChannels(projectId, deviceClass);
        await dataDispatch(setFirmwareChannels(projectId, channels, searchParamsToString({
            deviceClass,
        })));
    };
};
/**
 * Get multiple firmware bundles belonged to a Project
 * @param projectId - The id of the project to look for
 */
export const fetchProjectFirmwareBundles = (projectId, deviceClass) => {
    return async (dataDispatch) => {
        const bundles = await RitzAPI.getInstance().getProjectFirmwareBundles(projectId, deviceClass);
        await dataDispatch(setFirmwareBundles(projectId, bundles, searchParamsToString(deviceClass)));
    };
};
